import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import SortableTree, { addNodeUnderParent, removeNodeAtPath, changeNodeAtPath, toggleExpandedForAll } from '@nosferatu500/react-sortable-tree';
import Modal from '../../Modal/CustomModal';
import { Button, Row, Col } from 'reactstrap';
import { Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import '@nosferatu500/react-sortable-tree/style.css';
import SortableTreeForm from './SortableTreeForm';
import Toast from './../../Toast/Toast'
import { useSelector, useDispatch } from 'react-redux';
import { v4 as uuid } from 'uuid';

const Tree = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const session = useSelector((state) => { return state.core.session })
  const sessionKey = 'core-sorteable-data-' + props.name;

  const getNodeKey = ({ treeIndex }) => treeIndex;
  const defaultProps = {
   
    value: [
      { title: props.labelNewItem?props.labelNewItem:'Novo Item' },
    ],
    levelsLimit: 2,
    labelNewItem: 'Novo Item',
    labelTitleModal: 'Editar Item',
    afterSubmit: treeData => { },
    wrapTitle: item => {
      return item.title;
    }
  }
  props = { ...defaultProps, ...props };

  let addIdsTree = tree => {
    return tree.map(tree => {
      tree._id = tree._id?tree._id:uuid();
      if(tree.children){
        tree.children = addIdsTree(tree.children)
      }
      return tree;
    })
  }
  let [treeData, setTreeData] = useState(props.value ? addIdsTree(props.value) : addIdsTree(defaultProps.value));
  dispatch({ type: 'UPDATE_SESSION', key: sessionKey, value: treeData });

  let [showModal, setShowModal] = useState('');
  let [modalTitle, setModalTitle] = useState(props.labelTitleModal);
  let [modalContent, setModalContent] = useState('');

  const handleChange = treeData => {
    setTreeData(treeData);

    props.onChange({
      target: {
        name: props.name,
        value: treeData
      }
    });
    dispatch({ type: 'UPDATE_SESSION', key: sessionKey, value: treeData });
  }

  const handleSubmit = async (fields, values, currentNode) => {
    Toast.success('Informações atualizadas com sucesso!');
    const path = currentNode.path;
    currentNode.node = {...currentNode.node,...values}
    let tempTreeData = changeNodeAtPath({
      treeData: treeData,
      path,
      getNodeKey,
      newNode: currentNode.node,
      expandParent: true
    });
    setTreeData(tempTreeData);
    dispatch({ type: 'UPDATE_SESSION', key: sessionKey, value: tempTreeData });
    setShowModal(false);
  }

  const loadForm = (node) => {
    return (
      <div style={{ minHeight: 250 }}>
        <SortableTreeForm 
          customValidators={props.customValidators} 
          fields={props.fields}
          values={node.node} 
          handleSubmit={handleSubmit} 
          currentNode={node} 
        />
      </div>
    )
  }

  useEffect(() => {
      props.onChangeTreeData(treeData);
  }, [treeData]);

  return (
    <div style={{ height: 400 }} ref={ref}>
      <SortableTree
        treeData={treeData}
        onChange={treeData => handleChange(treeData)}
        generateNodeProps={({ node, path }) => {
          let title = node.title;
          if(props.wrapTitle){
            title = props.wrapTitle(node);
          }
          return {
            title: <div>{title}</div>,
            buttons: [
              <a
                className="btn btn-primary btn-sm btn-action"
                onClick={() => {
                  if (path.length <= props.levelsLimit) { 
                    let tempTreeData = addNodeUnderParent({
                      treeData: treeData,
                      parentKey: path[path.length - 1],
                      expandParent: true,
                      getNodeKey,
                      newNode: {
                        nodeKey: getNodeKey,
                        title: props.labelNewItem,
                        _id: uuid()
                      },
                    }).treeData;
                    setTreeData(tempTreeData);
                    dispatch({ type: 'UPDATE_SESSION', key: sessionKey, value: tempTreeData });
                  } else {
                    Toast.error('Limite de níveis atingido!')
                  }
                }}
              >
                <i class="fas fa-plus"></i>
              </a>
              ,
              <a
                className="btn btn-info btn-sm btn-action"
                onClick={() => {
                  setShowModal(true);
                  let info = {
                    data: treeData,
                    node: node,
                    path: path,
                    getNodeKey: getNodeKey
                  };
                  setModalContent(loadForm(info));
                }
                }
              >
                <i className="fas fa-pencil-alt"></i>
              </a>,
              <a
                class="btn btn-danger btn-sm btn-action"
                onClick={() => {
                    if(node.children && node.children.length>0){
                      Toast.error('Não é possível excluir um item que possua itens relacionados');
                    } else if(treeData[0]._id == node._id && treeData.length == 1){
                      Toast.error('Não é possível excluir o primeiro item.');
                    } else {
                      let tempTreeData = removeNodeAtPath({
                        treeData: treeData,
                        path,
                        getNodeKey,
                      });
                      setTreeData(tempTreeData);
                      dispatch({ type: 'UPDATE_SESSION', key: sessionKey, value: tempTreeData });          
                    }
                  }
                }
              >
                <i className="fas fa-trash">
                </i>
              </a>
            ],
          }
        }}
      />
      <Modal
        show={showModal}
        showButtons={false}
        handleShow={() => setShowModal(true)}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => setShowModal(true)}
        handleCancel={() => setShowModal(false)}
        title={modalTitle}
        content={modalContent}
      />
    </div>
  );

});


export default Tree;